import { Fade, Typography } from "@material-ui/core";
import { format } from "date-fns";
import { Fragment, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { AuthContext } from "../../context/context";
import { endoso, searchPoliza } from "../../services";
import { SnackBar, Spinner } from "../../shared/components";
import { AltaContext, CancelacionMasivaContext, EndosoContext } from "./context";
import {
  TIPO_CANCELACION_MASIVA,
  getMotivoResumenCancelacion,
  isCancelacionType,
} from "../../shared/utils/endosoTypes";
import { formatDate, generarInfoTabla } from "./hooks";
import { useSubmitData } from "./hooks/submitData";
import DataSection from "./sections/dataSection";
import FooterSection from "./sections/footerSection";
import FormsSection from "./sections/formsSection";
import FormTable from "./sections/formsSection/formTable";
import SelectSection from "./sections/selectSection";
import useStyles from "./styles";
const Endosos = () => {
  const classes = useStyles();
  /* history */
  const history = useHistory();
  /* new endosos */
  const { setTimer } = useContext(AuthContext);
  const {
    setAlertData,
    setCheckedPersons,
    formDta,
    setFormDta,
    showMessage,
    setShowMessage,
    message,
    setMessage,
    showButtons,
    setShowButtons,
    createMessage,
    setCargaB,
    cargaBData,
    setBajaRiesgo15,
    setAutos,
    setInfoTable,
    infoTable,
    spinner,
    setSpinner,
    selected,
  } = useContext(EndosoContext);
  const [dataContractor, setDataContractor] = useState();
  const { setInitialData, familiares, titulares, addPersonsSaved, file } =
    useContext(AltaContext);
  const { resetCancelacionMasiva } = useContext(CancelacionMasivaContext);
  /* state */
  const {
    state,
    direction,
    coberturas,
    persons,
    token,
    setPersons,
    setSections21,
    setCategorias902,
    setBajaAseguramiento,
    holder,
    setHolder,
  } = useContext(AuthContext);
  const isBlocked = Boolean(state?.status === "Cancelado" || state?.bloqueo);
  // Borrador de cancelacion pendiente: si ya se guardo el motivo, backend
  // devuelve la poliza como "Cancelado" (con bloqueo) aunque el endoso no se
  // haya confirmado. Se sigue mostrando para poder confirmarlo o cancelarlo.
  const esBorradorCancelacionPendiente = Boolean(
    state?.configuration &&
      state?.bloqueo &&
      isCancelacionType(state.configuration.tipoEndoso) &&
      !["CANCELADA", "CONFIRMADA"].includes(state.configuration.statusTable)
  );
  const polizaCancelada =
    state?.status === "Cancelado" && !esBorradorCancelacionPendiente;
  const [types, setType] = useState([]);
  const [rowsTable, setRowsTable] = useState({});
  const [errorsSelect, setErrorsSelect] = useState({});
  const [disableSelects, setDisableSelects] = useState(isBlocked ?? false);
  const [documents, setDocuments] = useState([]);
  const [dataSend, setDataSend] = useState({});
  const [oldData, setOldDat] = useState({});
  const [loading, setLoading] = useState(true);
  const [suplemento, setSuplemento] = useState({
    suplemLogico: state?.configuration?.suplemLogico || 0,
  });
  const [data, setData] = useState({
    oficina: state?.oficina || "",
    poliza: state?.poliza || "",
    ramo: state?.ramo || "",
    fechainicial: state?.configuration?.fechainicial || null,
    tipend: state?.configuration?.tipoEndoso || "",
    descripcionEndoso: state?.configuration?.descripcionEndoso || "",
  });
  // const { maxHolders } = useMemo(() => {
  //   if (!holder.amount) {
  //     return { maxHolders: true };
  //   }
  //   const filterSelected =
  //     selected?.filter((select) => Number(select.codigo) % 10 === 0) || [];

  //   return {
  //     maxHolders: holder.amount - filterSelected?.length >= 10,
  //   };
  // }, [selected, holder]);

  const { handleSubmitData: submitData } = useSubmitData();
  const handleDocuments = async () => {
    if (state?.configuration?.noSolicitud === undefined) return;
    if (state?.configuration?.statusTable === "PENDIENTE") return;
    const response = await searchPoliza.documents(
      state?.configuration?.noSolicitud,
      state?.configuration?.tipoEndoso >= 21 &&
        state?.configuration?.tipoEndoso <= 23
        ? "P"
        : "PE",
      state?.oficina || "",
      state?.ramo || "",
      state?.poliza || "",
      state?.configuration?.suplemLogico || ""
    );
    setSuplemento({
      suplemLogico: state?.configuration?.suplemLogico || 0,
    });

    if (response) setDocuments(response.data);
  };

  useEffect(() => {
    handleDocuments();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  /* methods */
  const handleChangeData = (e) => {
    setTimer(0);
    if (e.target.name === "tipend") {
      setData({
        ...data,
        [e.target.name]: e.target.value.idEndoso,
        descripcionEndoso: e.target.value.descEndoso,
      });
    } else {
      setData({ ...data, [e.target.name]: e.target.value });
    }
  };
  const handleSubmitData = async () => {
    const dataSend16 = {
      familiares: familiares,
      titulares: titulares,
      addPersonsSaved: addPersonsSaved,
      file: file,
    };
    setTimer(0);
    const submitProps = {
      setSpinner: setSpinner,
      data: data,
      oldData: oldData,
      dataSend:
        data.tipend === 16 || data.tipend === 12
          ? dataSend16
          : data.tipend === 20
          ? cargaBData
          : dataSend,
      setMessage: setMessage,
      setShowMessage: setShowMessage,
      direction: direction,
      formDta: formDta,
      endoso: endoso,
      setInfoTable: setInfoTable,
      setShowButtons: setShowButtons,
      showButtons: showButtons,
      coberturas: coberturas,
      rowsTable: rowsTable,
      persons: persons,
      setPersons: setPersons,
      setAlertData: setAlertData,
      setCheckedPersons: setCheckedPersons,
      createMessage: createMessage,
      history: history,
    };
    await submitData(submitProps);
  };

  // Cancelaciones (5, 51-54): si hay un solo Motivo de anulacion (o el
  // borrador retomado ya lo tiene guardado) se pasa directo al resumen. NO se
  // llama a endoso/guarda aqui: backend marca la poliza como "Cancelado" en
  // ese guarda, asi que con motivo unico se guarda al Confirmar endoso
  // (footerSection). Retorna false si hay que mostrar el formulario.
  const mostrarResumenCancelacion = (items, nextShowButtons) => {
    const resumen = getMotivoResumenCancelacion(data.tipend, items.datosEndoso);
    if (!resumen) return false;
    const valoresOriginales = {};
    items.datosEndoso.forEach((item) => {
      valoresOriginales[item.acronimo] = item.valorActual;
    });
    valoresOriginales.MOTANU = null;
    setInfoTable(
      generarInfoTabla(
        valoresOriginales,
        { ...valoresOriginales, MOTANU: resumen.motivo },
        data.tipend,
        items
      )
    );
    setShowButtons({
      ...nextShowButtons,
      infoTable: true,
      domicilio: false,
      motivoAutomatico: resumen.unico,
    });
    return true;
  };

  const snackbarMessage = ({ text, severity }) => {
    setMessage({
      text,
      severity,
      time: 4000,
    });
    setShowMessage(true);
  };
  useEffect(() => {
    const getBloquea = async () => {
      setSpinner(true);
      const dateIntial = format(new Date(data.fechainicial), "dd/MM/yyyy");

      const searchBody = {
        ...data,
        fechainicial: dateIntial,
        usuario: token.cdUsuario,
      };
      const bloqueaResponse = await searchPoliza.bloquea(searchBody);
      if (
        bloqueaResponse &&
        !bloqueaResponse.data?.error?.[0]?.desError &&
        data.tipend === 14 &&
        bloqueaResponse.data.alerta
      ) {
        createMessage({
          text: bloqueaResponse.data.alerta,
          variant: "success",
        });
      }
      if (bloqueaResponse.data?.error?.[0]?.desError) {
        if (data.tipend === 3) {
          setErrorsSelect({
            ...errorsSelect,
            date: bloqueaResponse.data?.error?.[0].desError,
          });
        } else {
          setErrorsSelect({
            ...errorsSelect,
            select: bloqueaResponse.data?.error?.[0].desError,
          });
        }
      } else {
        setErrorsSelect({});
      }
      if (bloqueaResponse.data?.codigo === 1) {
        setSuplemento({
          suplemLogico: bloqueaResponse.data.suplemLogico,
        });
        setDisableSelects(true);
        if (data.tipend === 12) {
          setFormDta({
            nivel: bloqueaResponse.data.nivel,
            suplemLogico: bloqueaResponse.data.suplemLogico,
            noSolicitud: bloqueaResponse.data?.nsolicitud,
          });
          setShowButtons({
            ...showButtons,
            highRisk: true,
            guardarEndoso: true,
          });
        } else if (Number(data.tipend) === TIPO_CANCELACION_MASIVA) {
          /* HU8: el tipo 55 no tiene endpoint de configuracion propio; solo
             necesita la solicitud para el upload y el previo. */
          resetCancelacionMasiva();
          setFormDta({
            nivel: bloqueaResponse.data.nivel ?? 1,
            suplemLogico: bloqueaResponse.data.suplemLogico,
            noSolicitud: bloqueaResponse.data.nsolicitud,
          });
          setShowButtons({ ...showButtons, guardarEndoso: true });
        } else if (data.tipend === 18) {
          const body = {
            oficina: data.oficina,
            ramo: data.ramo,
            poliza: data.poliza,
          };
          const res = await endoso.configModDescripcion(body);
          if (res.data?.codigo === "1") {
            setFormDta({
              nivel: 1,
              noSolicitud: bloqueaResponse.data.nsolicitud,
              tipoEndoso: data.tipend,
            });
            setAutos(res.data.autos);
          }
        } else if (data.tipend === 16) {
          const data = await endoso.configType16(
            bloqueaResponse.data.nsolicitud
          );
          if (data?.data.codigo === 1) {
            setFormDta({
              nivel: 1,
              noSolicitud: bloqueaResponse.data.nsolicitud,
            });
            setShowButtons({ ...showButtons, guardarEndoso: true });
            setInitialData(data.data);
          } else {
            createMessage({
              text: data?.data?.mensaje ?? "Ocurrio un error con su solicitud",
              variant: "warning",
            });
          }
        } else if (data.tipend === 15) {
          const data = await endoso.nivel902({
            solicitud: bloqueaResponse.data.nsolicitud,
            nivel: bloqueaResponse.data.nivel,
            pagina: 1,
            clave: null,
          });
          if (data?.data.codigo === 1) {
            const aseguramiento = await endoso.configType14(
              bloqueaResponse.data.nsolicitud
            );
            setHolder((prev) => ({
              ...prev,
              amount: aseguramiento?.data?.titulares?.length ?? 0,
            }));
            setBajaAseguramiento(aseguramiento?.data?.formaAseguramiento);
            setBajaRiesgo15(data.data);
            setShowButtons({ ...showButtons, guardarEndoso: true });
            setFormDta({
              ...formDta,
              nivel: bloqueaResponse.data.nivel,
              suplemLogico: bloqueaResponse.data.suplemLogico,
              noSolicitud: bloqueaResponse.data?.nsolicitud,
              tipoEndoso: 15,
              cantidad: data.data.cantidad,
            });
            setSuplemento({
              suplemLogico: bloqueaResponse.data.suplemLogico,
            });
          } else {
            createMessage({
              text: data?.data?.mensaje ?? "Ocurrio un error con su solicitud",
              variant: "warning",
            });
          }
        } else if (data.tipend === 14) {
          const dataBody = {
            oficina: data.oficina,
            poliza: data.poliza,
            ramo: data.ramo,
          };
          const dataResponse = await endoso.validaRegla902(dataBody);
          setCategorias902(
            dataResponse?.data?.codigo === 1 &&
              Array.isArray(dataResponse.data.categorias)
              ? dataResponse.data.categorias
              : []
          );
          const config = await endoso.configType14(
            bloqueaResponse.data.nsolicitud
          );
          setHolder((prev) => ({
            ...prev,
            amount: config?.data?.titulares?.length ?? 0,
          }));
          setInitialData(config?.data);
          setFormDta({
            nivel: bloqueaResponse.data.nivel,
            suplemLogico: bloqueaResponse.data.suplemLogico,
            noSolicitud: bloqueaResponse.data?.nsolicitud,
          });
          setSuplemento({
            suplemLogico: bloqueaResponse.data.suplemLogico,
          });
          setShowButtons({
            ...showButtons,
            highRisk: true,
            guardarEndoso: true,
          });
        } else if (data.tipend === 20) {
          const res = await endoso.configType20(
            bloqueaResponse.data?.nsolicitud
          );
          if (res?.data?.codigo === "1") {
            setCargaB(res.data);
            setFormDta({
              nivel: bloqueaResponse.data.nivel,
              suplemLogico: bloqueaResponse.data.suplemLogico,
              noSolicitud: bloqueaResponse.data?.nsolicitud,
            });
            setSuplemento({
              suplemLogico: bloqueaResponse.data.suplemLogico,
            });
            setShowButtons({
              ...showButtons,
              guardarEndoso: true,
              formulario: true,
            });
          } else
            createMessage({
              text: res?.data?.mensaje ?? "Ocurrio un error con su solicitud",
              variant: "warning",
            });
        } else if (data.tipend === 21) {
          const res = await endoso.secctions21(
            bloqueaResponse.data?.nsolicitud
          );
          if (res?.data?.codigo === 1) {
            setSections21(res?.data?.secciones);
          }
          setFormDta({
            nivel: 1,
            suplemLogico: bloqueaResponse.data.suplemLogico,
            noSolicitud: bloqueaResponse.data?.nsolicitud,
          });
          setShowButtons({
            ...showButtons,
            guardarEndoso: true,
          });
        } else if (data.tipend === 22) {
          setFormDta({
            nivel: 1,
            suplemLogico: bloqueaResponse.data.suplemLogico,
            noSolicitud: bloqueaResponse.data?.nsolicitud,
          });
          setShowButtons({
            ...showButtons,
            guardarEndoso: true,
          });
        } else if (data.tipend === 23) {
          setFormDta({
            nivel: 1,
            suplemLogico: bloqueaResponse.data.suplemLogico,
            noSolicitud: bloqueaResponse.data?.nsolicitud,
          });
          setShowButtons({
            ...showButtons,
            guardarEndoso: true,
          });
        } else if (data.tipend === 24) {
          setFormDta({
            nivel: 1,
            llave: "001",
            suplemLogico: bloqueaResponse.data.suplemLogico,
            noSolicitud: bloqueaResponse.data?.nsolicitud,
          });
          setShowButtons({
            ...showButtons,
            guardarEndoso: true,
          });
        } else if (data.tipend === 26) {
          /* texto fijo: no pasa por poliza/configuracion ni endoso/nivel */
          setFormDta({
            nivel: 1,
            suplemLogico: bloqueaResponse.data.suplemLogico,
            noSolicitud: bloqueaResponse.data?.nsolicitud,
          });
          setShowButtons({
            ...showButtons,
            guardarEndoso: true,
            /* sin formulario: el boton debe decir "Confirmar Endoso" de entrada */
            infoTable: true,
          });
        } else {
          /* configuration */
          if (bloqueaResponse.data.nivel === 1) {
            const body = {
              solicitud: bloqueaResponse.data.nsolicitud,
              nivel: bloqueaResponse.data.nivel,
              llave: null,
            };
            const configResponse = await endoso.configuration(body);
            if (
              configResponse.data?.codigo === 1 ||
              configResponse.data?.mensaje ===
                "No hay una persona con el rol BP"
            ) {
              const items = { ...configResponse.data };
              items.nivel = bloqueaResponse.data.nivel;
              items.suplemLogico = bloqueaResponse.data.suplemLogico;
              items.noSolicitud = bloqueaResponse.data?.nsolicitud;
              setFormDta(items || {});
              const nextShowButtons = {
                ...showButtons,
                formulario: true,
                formTable: false,
                guardarEndoso: true,
              };
              setSuplemento({
                suplemLogico: bloqueaResponse.data.suplemLogico,
              });
              if (!mostrarResumenCancelacion(items, nextShowButtons))
                setShowButtons(nextShowButtons);
            } else {
              setMessage({
                text:
                  configResponse.data?.mensaje ||
                  "Ocurrio un error con su solicitud",
                severity: "warning",
              });
              setFormDta({
                nivel: bloqueaResponse?.data?.nivel,
                noSolicitud: bloqueaResponse.data?.nsolicitud,
              });
              setShowMessage(true);
            }
          } else {
            /* levels */
            const body = {
              solicitud: bloqueaResponse.data.nsolicitud,
              nivel:
                bloqueaResponse.data.nivel === 3
                  ? 2
                  : bloqueaResponse.data.nivel,
              clave: null,
            };
            const levelResponse = await endoso.getLevel(body);
            if (levelResponse.data?.codigo === 1) {
              setRowsTable(levelResponse.data);
              setFormDta(
                {
                  nivel: bloqueaResponse.data?.nivel,
                  noSolicitud: bloqueaResponse.data?.nsolicitud,
                  suplemLogico: bloqueaResponse.data.suplemLogico,
                  niveles: levelResponse.data?.niveles,
                } || {}
              );
              setSuplemento({
                suplemLogico: bloqueaResponse.data.suplemLogico,
              });
              if (data.tipend === 17) {
                setShowButtons({
                  ...showButtons,
                  formulario: false,
                  formTable: true,
                  guardarEndoso: true,
                  multiTableBaja: true,
                });
              } else if (data.tipend === 13 || data.tipend === 15) {
                setShowButtons({
                  ...showButtons,
                  formulario: false,
                  formTable: true,
                  check: true,
                  guardarEndoso: true,
                });
              } else {
                setShowButtons({
                  ...showButtons,
                  formulario: false,
                  formTable: true,
                  guardarEndoso: false,
                });
              }
            } else {
              setMessage({
                text:
                  bloqueaResponse.data?.mensaje ||
                  "Ocurrio un error con su solicitud",
                severity: "warning",
              });
              setShowMessage(true);
            }
          }
        }
      } else {
        setTimeout(() => {
          setMessage({
            text:
              bloqueaResponse.data?.mensaje?.length < 70
                ? bloqueaResponse.data.mensaje
                : "La póliza esta bloqueada",
            severity: "warning",
          });

          setShowMessage(true);
        }, 500);
      }
      setSpinner(false);
    };
    if (data.fechainicial === undefined && data.tipend) {
      setErrorsSelect({
        ...errorsSelect,
        date: "DEBE SELECCIONAR AL MENOS UNA FECHA",
      });
    } else if (data.fechainicial && data.tipend && !state.configuration) {
      setErrorsSelect({});
      const dateIntial = format(data.fechainicial, "dd/MM/yyyy");
      if (
        new Date(formatDate(state.finVigencia)).getTime() -
          new Date(formatDate(dateIntial)) <
          0 ||
        new Date(formatDate(state.iniVigencia)).getTime() -
          new Date(formatDate(dateIntial)) >
          0
      ) {
        setMessage({
          text: "Fecha fuera de vigencia",
          severity: "warning",
        });
        setShowMessage(true);
      } else {
        setMessage({
          text: "FECHA CORRECTA, FECHA ACTUAL SELECCIONADA",
          severity: "success",
        });
        setShowMessage(true);
        getBloquea();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  useEffect(() => {
    if (state?.mensajeBloqueo) {
      setMessage({
        text: state.mensajeBloqueo,
        severity: "warning",
      });
      setShowMessage(true);
    }
    const getTypesEndoso = async () => {
      const typesResponse = await endoso.listType(
        state.ramo === 902 || state.ramo === 606 ? state : state.ramo
      );

      setType(typesResponse.data?.endosos || []);
      if (state.configuration) {
        /* set type of endoso */
        if (data.tipend === 18) {
          setAutos(state.configuration.initialData);
          setFormDta(state.configuration);
        } else if (state.configuration.nivel === 1) {
          setFormDta(state.configuration);
          if (data.tipend === 12) {
            setShowButtons({
              ...showButtons,
              highRisk: true,
              guardarEndoso: true,
            });
          } else if (data.tipend === 16) {
            setFormDta(state.configuration);
            setShowButtons({ ...showButtons, guardarEndoso: true });
            setInitialData(state?.configuration?.initialData);
          } else if (data.tipend === 14) {
            setInitialData(state?.configuration?.initialData);
            setFormDta(state.configuration);
            setShowButtons({
              ...showButtons,
              highRisk: true,
              guardarEndoso: true,
            });
          } else if (data.tipend === 20) {
            setFormDta(state.configuration);
            setCargaB(state.configuration.initialData);
            setShowButtons({
              ...showButtons,
              guardarEndoso: true,
              formulario: true,
            });
          } else if (data.tipend === 21) {
            setFormDta(state.configuration);
            setShowButtons({
              ...showButtons,
              guardarEndoso: true,
            });
          } else if (data.tipend === 22) {
            setFormDta(state.configuration);
            setShowButtons({
              ...showButtons,
              guardarEndoso: true,
            });
          } else if (data.tipend === 23) {
            setFormDta(state.configuration);
            setShowButtons({
              ...showButtons,
              guardarEndoso: true,
            });
          } else if (data.tipend === 24) {
            setFormDta({ ...state.configuration, llave: "001" });
            setShowButtons({
              ...showButtons,
              guardarEndoso: true,
            });
          } else if (data.tipend === 26) {
            setFormDta(state.configuration);
            setShowButtons({
              ...showButtons,
              guardarEndoso: true,
              infoTable: true,
            });
          } else {
            if (state.configuration?.codigo === 1) {
              const nextShowButtons = {
                ...showButtons,
                formulario: true,
                formTable: false,
                guardarEndoso: true,
              };
              // Borrador retomado desde el dashboard: solo si sigue abierto
              const borradorAbierto = !["CANCELADA", "CONFIRMADA"].includes(
                state.configuration.statusTable
              );
              if (
                !borradorAbierto ||
                !mostrarResumenCancelacion(state.configuration, nextShowButtons)
              )
                setShowButtons(nextShowButtons);
            } else {
              setMessage({
                text:
                  state.configuration?.mensaje ||
                  "Ocurrio un error con su solicitud",
                severity: "warning",
              });
              setShowMessage(true);
              if (data.tipend === 6) {
                setShowButtons({
                  ...showButtons,
                  formulario: true,
                  formTable: false,
                  guardarEndoso: true,
                });
              }
            }
          }
        } else {
          setRowsTable(state.configuration);
          setFormDta(state.configuration);
          if (data.tipend === 17) {
            setShowButtons({
              ...showButtons,
              formulario: false,
              formTable: true,
              guardarEndoso: true,
              multiTableBaja: true,
            });
          } else if (data.tipend === 15) {
            setFormDta({ ...state.configuration, cantidad: state.cantidad });
            setShowButtons({ ...showButtons, guardarEndoso: true });
            setBajaRiesgo15(state?.configuration?.initialData);
          } else if (data.tipend === 13 || data.tipend === 15) {
            setShowButtons({
              ...showButtons,
              formulario: false,
              formTable: true,
              check: true,
              guardarEndoso: true,
            });
          } else {
            setShowButtons({
              ...showButtons,
              formulario: false,
              formTable: true,
              guardarEndoso: false,
            });
          }
        }
        setDisableSelects(true);
      }
      setLoading(false);
    };
    if (state === undefined) history.push("/");
    else {
      getTypesEndoso();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (loading) {
    return <Spinner />;
  } else
    return (
      <Fragment>
        <SnackBar
          HandleShow={setShowMessage}
          show={showMessage}
          severity={message.severity}
          text={message.text}
          time={message.time ?? 15000}
          action={message.action}
        />
        <Fade in={!loading} timeout={600}>
          <div className={classes.root}>
            <div className={classes.sections}>
              <DataSection dataPoliza={state} dataContractor={dataContractor} />
            </div>

            <div className={classes.sections}>
              <div className={classes.subSections}>
                <Typography variant="h5" className={classes.title}>
                  <strong>Endoso</strong>
                </Typography>
              </div>
              <div className={classes.subSections}>
                <SelectSection
                  options={types}
                  change={handleChangeData}
                  data={data}
                  disableSelects={disableSelects}
                  error={errorsSelect}
                />
              </div>

              <div id="forms" className={classes.subSections}>
                {formDta.statusTable !== "CANCELADA" &&
                  formDta.statusTable !== "CONFIRMADA" &&
                  !polizaCancelada && (
                    <>
                      {/* {!maxHolders && (
                        <Box className={classes.header}>
                          <Typography className={classes.error}>
                            El movimiento solicitado no puede ejecutarse debido
                            a que no cumple con el mínimo de asegurados activos
                            para este producto
                          </Typography>
                        </Box>
                      )} */}
                      <FormsSection
                        loading={loading}
                        formDta={formDta}
                        rows={rowsTable}
                        setRows={setRowsTable}
                        setFormDta={setFormDta}
                        spinner={spinner}
                        setSpinner={setSpinner}
                        setMessage={setMessage}
                        snackbarMessage={snackbarMessage}
                        setShowMessage={setShowMessage}
                        dataSend={dataSend}
                        setData={setDataSend}
                        setOldDat={setOldDat}
                        showButtons={showButtons}
                        infoTable={infoTable}
                        data={data}
                        setShowButtons={setShowButtons}
                        errorsSelect={errorsSelect}
                        holders={holder.amount}
                      />
                    </>
                  )}
                {formDta.statusTable === "CONFIRMADA" && (
                  <FormTable rows={documents} type={2} actionHeader />
                )}
              </div>
              <div className={classes.subSections}>
                {formDta.statusTable !== "CANCELADA" &&
                  formDta.statusTable !== "CONFIRMADA" &&
                  !polizaCancelada && (
                    <FooterSection
                      setMessage={setMessage}
                      setShowMessage={setShowMessage}
                      setSpinner={setSpinner}
                      submit={handleSubmitData}
                      showButtons={showButtons}
                      // disableDraft={!maxHolders}
                      spinner={spinner}
                      formDta={formDta}
                      setShowButtons={setShowButtons}
                      data={data}
                      dataSend={dataSend}
                      setDataContractor={setDataContractor}
                      suplemLogico={suplemento.suplemLogico}
                    />
                  )}
              </div>
            </div>
          </div>
        </Fade>
      </Fragment>
    );
};

export default Endosos;
